import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    const token = localStorage.getItem("r2w_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/me");
      setUser(data);
    } catch { localStorage.removeItem("r2w_token"); }
    setLoading(false);
  };

  useEffect(() => { loadMe(); }, []);

  const login = async (accountId, pin) => {
    const { data } = await api.post("/auth/login", { account_id: accountId, pin });
    localStorage.setItem("r2w_token", data.token);
    await loadMe();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("r2w_token");
    setUser(null);
    window.location.href = "/";
  };

  // Auto log-off after 30 minutes of inactivity (any interaction resets the timer).
  useEffect(() => {
    if (!user) return;
    let timer;
    const reset = () => { clearTimeout(timer); timer = setTimeout(() => { logout(); }, 30 * 60 * 1000); };
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => { clearTimeout(timer); events.forEach((e) => window.removeEventListener(e, reset)); };
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, canSeeMoney: user?.can_see_money }}>
      {children}
    </AuthContext.Provider>
  );
}
